import * as React from 'react';
import { Menu } from '@easyv/react-components';

export type DropListMenuOption = {
  key: string;
  label: React.ReactNode;
  icon?: React.ReactNode;
  visible?: boolean;
  onSelected: () => void;
};

/** 如果返回()=>JSX.Element而不是Element的话会影响arcod的样式 */
export const getDropListMenu = (options: DropListMenuOption[]) => (
  <Menu>
    {options.map((o) => {
      return o.visible === false ? null : (
        <Menu.Item
          key={o.key}
          onClick={o.onSelected}
          className='!h-8 !w-[120px] acro-dropdown-menu-item'
        >
          {o.icon}
          <div className='ml-2'>{o.label}</div>
        </Menu.Item>
      );
    })}
  </Menu>
);
